import { MessageSender, MessageBus, State } from "../../../common";
import { internalMessageBus } from "sb-internal-msg-bus";
import { MarketGroupsRetriever, MarketGroupsGateway } from "../retriever";
import { MarketGroupsParser } from "../parser";
import { outrightsQueryFactory } from "../queries";
import { MarketGroupsMapper } from "../mapper";
import { defaultItemForSportMode } from "../../sports";
export const marketGroupsStateFactory = (cms, domId) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new State(messageSender, cms.blockId, domId, defaultItemForSportMode.firstMarket, cms.isAllOutrightsFirst);
};
export const marketGroupsRetrieverFactory = (cms, dict, gateway) => {
    let marketGroupsGateway = new MarketGroupsGateway(gateway, outrightsQueryFactory, new MarketGroupsMapper(), cms.isAllOutrightsFirst);
    return new MarketGroupsRetriever(marketGroupsGateway, dict);
};
export const marketGroupsParserFactory = (cms, retriever) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new MarketGroupsParser(retriever, messageSender);
};
//# sourceMappingURL=factories.js.map